import { render, staticRenderFns } from "./PublicGoals.vue?vue&type=template&id=6ed90c3c"
import script from "./PublicGoals.vue?vue&type=script&lang=js"
export * from "./PublicGoals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports